import { render, staticRenderFns } from "./InputIconGroup.vue?vue&type=template&id=5bf93d84&"
import script from "./InputIconGroup.vue?vue&type=script&lang=js&"
export * from "./InputIconGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports